import gql from "graphql-tag";
import PostOrReplyAuthorFields from "lib/graphql/fragments/engagement/PostOrReplyAuthorFields";
import ReactableFields from "lib/graphql/fragments/ReactableFields";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  query PostReplies($postShortId: ID!, $cursor: Cursor, $limit: Int = 8) {
    postByShortId(postShortId: $postShortId) {
      _id
      shortId
      bodyAsJson
      bodyAsPlainText
      author {
        ...PostOrReplyAuthorFields
      }
      createdAt

      ... on IrpfPost {
        title
        url

        lastRepliedAt
        isPinned
        isLocked

        replyAnswer {
          shortId
          bodyAsJson
          bodyAsPlainText
          createdAt
          author {
            ...PostOrReplyAuthorFields
          }
        }

        ...ReactableFields
      }

      viewerCanViewReplies
      viewerDidAuthor
      viewerCanEdit
      viewerCanDestroy
      viewerCanReply

      replies(cursor: $cursor, limit: $limit) {
        nodes {
          ...PostReplyFields
        }
        totalCount
        pageInfo {
          cursor
          hasNextPage
        }
      }
    }
  }

  ${PostReplyFields}
  ${PostOrReplyAuthorFields}
  ${ReactableFields}
`;
